import React, { useContext } from 'react';

import cx from 'classnames';
import { useIntl, FormattedMessage } from 'react-intl';

import { Headline, BodyCopy } from '@xingternal/typography';
import { Button } from '@xingternal/button';
import { PageContext } from '@xingternal/pages-common';

import styles from './UpsellBanner.css';
import Icon from './images/upsell_icon_green.png';
import { getMarketingPageUrl } from './utils';

type UpsellBannerVerticalProps = {
  headerCopyKey: string;
  bodyCopyKey: string;
  moduleName: string;
};

const UpsellBannerVertical = ({
  headerCopyKey,
  bodyCopyKey,
  moduleName,
}: UpsellBannerVerticalProps) => {
  const intl = useIntl();
  const { pageContext } = useContext(PageContext);

  const marketingPageUrl = getMarketingPageUrl({
    locale: intl.locale,
    moduleName,
    focusType: pageContext?.focusType,
  });

  return (
    <div className={styles.premiumWrapperVertical}>
      <div className={cx(styles.contentWrapper, styles.padding)}>
        <div className={styles.textWrapper}>
          <span className={styles.flag}>
            <FormattedMessage id="EP_FLAG_EMPLOYER_BRANDING_PROFILE" />
          </span>
          <div className={styles.headerText}>
            <Headline size="xlarge">
              <FormattedMessage id={headerCopyKey} />
            </Headline>
          </div>
          <BodyCopy className={styles.text}>
            <FormattedMessage id={bodyCopyKey} />
          </BodyCopy>
        </div>
        <div className={styles.premiumButtonMargin}>
          <Button
            size="medium"
            variant="proBusiness"
            className={styles.premiumButton}
            href={marketingPageUrl}
            target="_blank"
            rel="noreferrer noopener nofollow"
          >
            <FormattedMessage id="EP_UPSELL_GALLERY_BUTTON" />
          </Button>
        </div>
      </div>
      <img className={styles.iconVertical} src={Icon} alt="Upsell icon green" />
    </div>
  );
};

export default UpsellBannerVertical;
